import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ScreenSizeService } from "@/common/screen-size.service";


@Injectable()
export class AuthcodeHttpService {
    constructor(private httpClient: HttpClient ,
                private screenSizeService: ScreenSizeService,) { }

    authcode(data: { authCode: string, screenSize?: string, token?: string, language?: string }): Observable<any> { 
        data.screenSize = this.screenSizeService.getScreenSize();
        data.language = localStorage.getItem('language') || null; 
        return this.httpClient.post<any>(`${ecorEnv.apiEndpoint}/authbank/authcode`, data) 
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        if (typeof error.error !== 'undefined' && error.error instanceof ErrorEvent) {
            console.error('ecorr-authcode-http', 'client side error:', error.error);
        } else {
            return throwError(error);
        }
        return throwError('Error-222222');
    }
}
